import { occupiedBoxSpaceForVariant } from '../../../utils/box-capacity';
import { isSelectableItem } from './item-filters';
export const buildSelectableUnits = (cartItems)=>cartItems.filter(isSelectableItem).flatMap((it)=>{
        const qty = Number(it.quantity) || 0;
        var _it_variant_id, _ref;
        const effectiveSpace = occupiedBoxSpaceForVariant(String((_ref = (_it_variant_id = it.variant_id) !== null && _it_variant_id !== void 0 ? _it_variant_id : it.id) !== null && _ref !== void 0 ? _ref : ''));
        var _it_title;
        return Array.from({
            length: qty
        }, (_, i)=>({
                unitKey: `${it.key}::${i}`,
                lineKey: it.key,
                index: i,
                title: (_it_title = it.title) !== null && _it_title !== void 0 ? _it_title : '',
                originalQuantity: qty,
                item: it,
                effectiveSpace
            }));
    });
